import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, palette, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const avatarSizes = variant({
  prop: "size",
  variants: {
    xxs: {
      height: "16px",
      width: "16px"
    },
    xs: {
      height: "24px",
      width: "24px"
    },
    sm: {
      height: "36px",
      width: "36px"
    },
    md: {
      height: "48px",
      width: "48px"
    },
    lg: {
      height: "64px",
      width: "64px"
    },
    xl: {
      height: "80px",
      width: "80px"
    },
    xxl: {
      height: "112px",
      width: "112px"
    },
    jb: {
      height: "176px",
      width: "176px"
    },
    mg: {
      height: "240px",
      width: "240px"
    }
  }
});
const Avatar = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
    border-radius: ${({ isRound }) => radius(isRound ? "round" : "sm")};

    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        border-radius: ${({ isRound }) => radius(isRound ? "round" : "sm")};
    }

    ${themeMode({
  dark: css`
            background-color: ${palette("neutral.700")};
            color: ${palette("neutral.50")};
        `,
  light: css`
            background-color: ${palette("neutral.300")};
            color: ${palette("neutral.900")};
        `
})};

    ${avatarSizes}
`;

export { Avatar };
//# sourceMappingURL=styled.es.js.map
